import type { ChargerRepository } from '@/core/charger'
import type { UseCase } from '@/core/shared'

export const getChargerEnergyCost: UseCase<ChargerRepository, 'getChargerEnergyCost'> = repository => {
  return async (chargerUid) => {
    return await repository.getChargerEnergyCost(chargerUid)
  }
}
